import { format } from "date-fns"
import i18next from "i18next"

export const daysOfWeek = [
  "Sunday",
  "Monday",
  "Tuesday",
  "Wednesday",
  "Thursday",
  "Friday",
  "Saturday",
]

export const filters = [
  {
    name: "status",
    type: "select",
    get options() {
      return [
        { label: i18next.t("All"), value: 2 },
        { label: i18next.t("Active"), value: 1 },
        { label: i18next.t("Deactive"), value: 0 },
      ]
    },
    get placeholder() {
      return i18next.t("All")
    },
  },
  {
    name: "sortOrder",
    type: "select",
    get options() {
      return [
        { label: i18next.t("Ascending"), value: 1 },
        { label: i18next.t("Descending"), value: 2 },
      ]
    },
    get placeholder() {
      return i18next.t("Ascending")
    },
  },
]

export const pageSizes = [10, 20, 30, 40, 50]

export const commonItemPerPage = 10

export const permissionsList = [
  {
    id: 1,
    title: "Dashboard",
    titleAr: "لوحة القيادة",
    permissions: [
      {
        id: "dashboard_1",
        value: "view",
        label: "Sales",
        labelAr: "مبيعات",
        isEnabled: false,
      },
      {
        id: "dashboard_2",
        value: "view",
        label: "Branches",
        labelAr: "الفروع",
        isEnabled: false,
      },
      {
        id: "dashboard_3",
        value: "view",
        label: "Bookings",
        labelAr: "الحجوزات",
        isEnabled: false,
      },
      {
        id: "dashboard_4",
        value: "view",
        label: "Ratings",
        labelAr: "الحجوزات",
        isEnabled: false,
      },
    ],
  },
  {
    id: 2,
    title: "Banners",
    titleAr: "لافتات",
    permissions: [
      {
        id: "inAppContent_1",
        value: "view",
        label: "View",
        labelAr: "عرض",
        isEnabled: false,
      },
      {
        id: "inAppContent_2",
        value: "add",
        label: "Add",
        labelAr: "إضافة",
        isEnabled: false,
      },
      {
        id: "inAppContent_3",
        value: "update",
        label: "Update",
        labelAr: "تحديث",
        isEnabled: false,
      },

      {
        id: "inAppContent_4",
        value: "delete",
        label: "Delete",
        labelAr: "حذف",
        isEnabled: false,
      },
    ],
  },
  // {
  //   id: 3,
  //   title: "Roles",
  //   permissions: [
  //     {
  //       id: "roles_1",
  //       value: "view",
  //       label: "View",
  //       labelAr: "عرض",
  //       isEnabled: false,
  //     },
  //     {
  //       id: "roles_2",
  //       value: "add",
  //       label: "Add",
  //       labelAr: "إضافة",
  //       isEnabled: false,
  //     },
  //     {
  //       id: "roles_3",
  //       value: "update",
  //       label: "Update",
  //       labelAr: "تحديث",
  //       isEnabled: false,
  //     },

  //     {
  //       id: "roles_4",
  //       value: "delete",
  //       label: "Delete",
  //       labelAr: "حذف",
  //       isEnabled: false,
  //     },
  //   ],
  // },
  {
    id: 4,
    title: "Menus",
    titleAr: "القوائم",
    permissions: [
      {
        id: "menus_1",
        value: "view",
        label: "View",
        labelAr: "عرض",
        isEnabled: false,
        subPermissions: [
          {
            id: "menu_full_access_view",
            value: "Full Access",
            label: "Full Access",
            labelAr: "الوصول الكامل",
            isEnabled: true,
          },
          {
            id: "item_access_view",
            value: "Item Access",
            label: "Item Access",
            labelAr: "الوصول إلى العناصر",
            isEnabled: true,
          },
          {
            id: "modifier_access_view",
            value: "Modifier Access",
            label: "Modifier Access",
            labelAr: "الوصول إلى العناصر",
            isEnabled: false,
          },
        ],
      },
      {
        id: "menus_2",
        value: "add",
        label: "Add",
        labelAr: "إضافة",
        isEnabled: false,
      },
      {
        id: "menus_3",
        value: "update",
        label: "Update",
        labelAr: "تحديث",
        isEnabled: false,
        subPermissions: [
          {
            id: "menu_full_access_update",
            value: "Full Access",
            label: "Full Access",
            labelAr: "الوصول الكامل",
            isEnabled: true,
          },
          {
            id: "enable_out_of_stock",
            value: "Mark As Out of Stock",
            label: "Mark As Out of Stock",
            labelAr: "تمكين نفاد المخزون",
            isEnabled: true,
          },
          {
            id: "enable_disable_item",
            value: "Enabled/Disabled Item",
            label: "Enabled/Disabled Item",
            labelAr: "العنصر الممكّن/المعطل",
            isEnabled: true,
          },
          {
            id: "enable_out_of_stock_modifier",
            value: "Mark As Out Of Stock Modifier",
            label: "Mark As Out Of Stock Modifier",
            labelAr: "تحديد كمعدل غير متوفر في المخزون",
            isEnabled: true,
          },
          {
            id: "clear_menu_cache",
            value: "Clear Menu Cache",
            label: "Clear Menu Cache",
            labelAr: "مسح ذاكرة تخزين القائمة",
            isEnabled: false,
          },
        ],
      },

      {
        id: "menus_4",
        value: "delete",
        label: "Delete",
        labelAr: "حذف",
        isEnabled: false,
      },
    ],
  },
  {
    id: 5,
    title: "Branch/Locations",
    titleAr: "الفروع/المواقع",
    permissions: [
      {
        id: "branchLocations_1",
        value: "view",
        label: "View",
        labelAr: "عرض",
        isEnabled: false,
      },
      {
        id: "branchLocations_2",
        value: "add",
        label: "Add",
        labelAr: "إضافة",
        isEnabled: false,
      },
      {
        id: "branchLocations_3",
        value: "update",
        label: "Update",
        labelAr: "تحديث",
        isEnabled: false,
        subPermissions: [
          {
            id: "edit_opening_hours",
            value: "Opening hours editing",
            label: "Opening hours editing",
            labelAr: "تحرير ساعات العمل",
            isEnabled: true,
          },
          {
            id: "edit_branch_status",
            value: "Branch active/deactive settings",
            label: "Branch active/deactive settings",
            labelAr: "فرع الإعدادات النشطة / غير النشطة",
            isEnabled: true,
          },
          {
            id: "edit_branch_name_settings",
            value: "Branch name settings",
            label: "Branch name settings",
            labelAr: "إعدادات اسم الفرع",
            isEnabled: true,
          },
          {
            id: "copy_branch_settings",
            value: "Copy branch settings",
            label: "Copy branch settings",
            labelAr: "نسخ إعدادات الفرع",
            isEnabled: true,
          },
          {
            id: "clone_branch",
            value: "Clone Branch",
            label: "Clone Branch",
            labelAr: "فرع الاستنساخ",
            isEnabled: true,
          },
          {
            id: "enable_pickup_curbside",
            value: "Enable Pickup/Curbside",
            label: "Enable Pickup/Curbside",
            labelAr: "تفعيل الاستلام / من الرصيف",
            isEnabled: true,
          },
          {
            id: "enable_dine_drive_thru",
            value: "Enable Dine In/Drive Thru ",
            label: "Enable Dine In/Drive Thru ",
            labelAr: "تمكين تناول الطعام في المطعم/الطلب من خلال خدمة السيارات",
            isEnabled: false,
          },
        ],
      },
    ],
  },
  {
    id: 6,
    title: "Users",
    titleAr: "المستخدمون",
    permissions: [
      {
        id: "usersPermission_1",
        value: "view",
        label: "View",
        labelAr: "عرض",
        isEnabled: false,
      },
      {
        id: "usersPermission_2",
        value: "add",
        label: "Add",
        labelAr: "إضافة",
        isEnabled: false,
      },
      {
        id: "usersPermission_3",
        value: "update",
        label: "Update",
        labelAr: "تحديث",
        isEnabled: false,
      },
      {
        id: "usersPermission_4",
        value: "delete",
        label: "Delete",
        labelAr: "حذف",
        isEnabled: false,
      },
    ],
  },
  {
    id: 7,
    title: "Customers",
    titleAr: "عملاء",
    permissions: [
      {
        id: "customersPermission_1",
        value: "view",
        label: "View",
        labelAr: "عرض",
        isEnabled: false,
        subPermissions: [
          {
            id: "view_device_information",
            value: "Device Information",
            label: "Device Information",
            labelAr: "معلومات الجهاز",
            isEnabled: true,
          },
          {
            id: "view_orders",
            value: "Orders",
            label: "Orders",
            labelAr: "طلبات",
            isEnabled: true,
          },
          {
            id: "view_loyalty_points",
            value: "Loyalty Points",
            label: "Loyalty Points",
            labelAr: "نقاط الولاء",
            isEnabled: true,
          },
          {
            id: "view_payment_history",
            value: "Payment History",
            label: "Payment History",
            labelAr: "طلبات",
            isEnabled: true,
          },
          {
            id: "view_wallet_history",
            value: "Wallet History",
            label: "Wallet History",
            labelAr: "تاريخ المحفظة",
            isEnabled: true,
          },
          {
            id: "view_gift_card_usage",
            value: "Eidiyah Usage",
            label: "Eidiyah Usage",
            labelAr: "استخدام العيدية",
            isEnabled: false,
          },
        ],
      },
      {
        id: "customersPermission_2",
        value: "update",
        label: "Update",
        labelAr: "تحديث",
        isEnabled: false,
      },

      {
        id: "customersPermission_4",
        value: "delete",
        label: "Delete",
        labelAr: "حذف",
        isEnabled: false,
      },
      {
        id: "customersPermission_5",
        value: "restore",
        label: "View deleted customers and Restore",
        labelAr: "عرض العملاء المحذوفين واستعادتهم",
        isEnabled: false,
      },
    ],
  },
  // {
  //   id: 8,
  //   title: "Feedback",
  //   permissions: [
  //     {
  //       id: "feedback_1",
  //       value: "view",
  //       label: "View",
  //       labelAr: "عرض",
  //       isEnabled: false,
  //     },
  //     {
  //       id: "feedback_2",
  //       value: "viewRatings",
  //       label: "View Ratings",
  //       labelAr: "عرض التقييمات",
  //       isEnabled: false,
  //     },
  //   ],
  // },
  {
    id: 9,
    title: "Orders",
    titleAr: "طلبات",
    permissions: [
      {
        id: "order_1",
        value: "view",
        label: "View",
        labelAr: "عرض",
        isEnabled: false,
      },
      {
        id: "order_2",
        value: "update",
        label: "Update",
        labelAr: "تحديث",
        isEnabled: false,
      },
    ],
  },
  // {
  //   id: 10,
  //   title: "Curbside Pickup",
  //   permissions: [
  //     {
  //       id: "curbside_1",
  //       value: "view",
  //       label: "View",
  //       labelAr: "عرض",
  //       isEnabled: false,
  //     },
  //     {
  //       id: "curbside_2",
  //       value: "update",
  //       label: "Update",
  //       labelAr: "تحديث",
  //       isEnabled: false,
  //     },
  //   ],
  // },
  {
    id: 11,
    title: "Countries",
    titleAr: "بلدان",
    permissions: [
      {
        id: "country_1",
        value: "view",
        label: "View",
        labelAr: "منظر",
        isEnabled: false,
      },
      {
        id: "country_2",
        value: "add",
        label: "Add",
        labelAr: "إضافة",
        isEnabled: false,
      },
      {
        id: "country_3",
        value: "update",
        label: "Update",
        labelAr: "تحديث",
        isEnabled: false,
      },

      {
        id: "country_4",
        value: "delete",
        label: "Delete",
        labelAr: "حذف",
        isEnabled: false,
      },
    ],
  },
  // {
  //   id: 12,
  //   title: "Tax (VAT)",
  //   titleAr: "ضريبة القيمة المضافة)",
  //   permissions: [
  //     {
  //       id: "tax_1",
  //       value: "view",
  //       label: "View",
  //       labelAr: "منظر",
  //       isEnabled: false,
  //     },
  //     {
  //       id: "tax_2",
  //       value: "update",
  //       label: "Update",
  //       labelAr: "تحديث",
  //       isEnabled: false,
  //     },
  //   ],
  // },
  {
    id: 13,
    title: "API Logs",
    titleAr: "سجلات API",
    permissions: [
      {
        id: "api_logs_1",
        value: "view",
        label: "View",
        labelAr: "عرض",
        isEnabled: false,
      },
    ],
  },
  {
    id: 14,
    title: "Discounts/Coupons",
    titleAr: "الخصومات/الكوبونات",
    permissions: [
      {
        id: "promotion_1",
        value: "view",
        label: "View",
        labelAr: "عرض",
        isEnabled: false,
      },
      {
        id: "promotion_2",
        value: "add",
        label: "Add",
        labelAr: "إضافة",
        isEnabled: false,
      },
      {
        id: "promotion_3",
        value: "update",
        label: "Update",
        labelAr: "تحديث",
        isEnabled: false,
      },

      {
        id: "promotion_4",
        value: "delete",
        label: "Delete",
        labelAr: "حذف",
        isEnabled: false,
      },
    ],
  },
  {
    id: 15,
    title: "Notifications",
    titleAr: "إشعارات",
    permissions: [
      {
        id: "notification_1",
        value: "view",
        label: "View",
        labelAr: "عرض",
        isEnabled: false,
      },

      {
        id: "notification_3",
        value: "update",
        label: "Update",
        labelAr: "تحديث",
        isEnabled: false,
      },
    ],
  },
  {
    id: 16,
    title: "Reports",
    titleAr: "التقارير",
    permissions: [
      {
        id: "report_1",
        value: "view",
        label: "View",
        labelAr: "عرض",
        isEnabled: false,
      },
    ],
  },
  {
    id: 17,
    title: "Customer Support",
    titleAr: "دعم العملاء",
    permissions: [
      {
        id: "customer_support_1",
        value: "view",
        label: "View",
        labelAr: "عرض",
        isEnabled: false,
      },
      {
        id: "customer_support_2",
        value: "add",
        label: "Add",
        labelAr: "إضافة",
        isEnabled: false,
      },
      {
        id: "customer_support_3",
        value: "update",
        label: "Update",
        labelAr: "تحديث",
        isEnabled: false,
      },

      {
        id: "customer_support_4",
        value: "delete",
        label: "Delete",
        labelAr: "حذف",
        isEnabled: false,
      },
    ],
  },
  {
    id: 18,
    title: "FAQ",
    titleAr: "التعليمات",
    permissions: [
      {
        id: "faq_1",
        value: "view",
        label: "View",
        labelAr: "عرض",
        isEnabled: false,
      },
      {
        id: "faq_2",
        value: "add",
        label: "Add",
        labelAr: "إضافة",
        isEnabled: false,
      },
      {
        id: "faq_3",
        value: "update",
        label: "Update",
        labelAr: "تحديث",
        isEnabled: false,
      },

      {
        id: "faq_4",
        value: "delete",
        label: "Delete",
        labelAr: "حذف",
        isEnabled: false,
      },
    ],
  },
  {
    id: 19,
    title: "Referral Settings",
    titleAr: "إعدادات الإحالة",
    permissions: [
      {
        id: "referral_1",
        value: "view",
        label: "View",
        labelAr: "عرض",
        isEnabled: false,
      },
      {
        id: "referral_3",
        value: "update",
        label: "Update",
        labelAr: "تحديث",
        isEnabled: false,
      },
    ],
  },
  {
    id: 20,
    title: "Loyalty Settings",
    titleAr: "إعدادات الولاء",
    permissions: [
      {
        id: "loyalty_1",
        value: "view",
        label: "View",
        labelAr: "عرض",
        isEnabled: false,
      },
      {
        id: "loyalty_3",
        value: "update",
        label: "Update",
        labelAr: "تحديث",
        isEnabled: false,
      },
    ],
  },
  {
    id: 21,
    title: "Bookings",
    titleAr: "الحجوزات",
    permissions: [
      {
        id: "booking_1",
        value: "view",
        label: "View",
        labelAr: "عرض",
        isEnabled: false,
      },
      {
        id: "booking_4",
        value: "delete",
        label: "Delete",
        labelAr: "حذف",
        isEnabled: false,
      },
    ],
  },
  {
    id: 22,
    title: "QR Code",
    titleAr: "رمز الاستجابة السريعة",
    permissions: [
      {
        id: "qr_code_1",
        value: "view",
        label: "View",
        labelAr: "عرض",
        isEnabled: false,
      },
      {
        id: "qr_code_3",
        value: "update",
        label: "Update",
        labelAr: "تحديث",
        isEnabled: false,
      },
    ],
  },
  {
    id: 23,
    title: "Ingredients",
    titleAr: "مكونات",
    permissions: [
      {
        id: "ingredient_1",
        value: "view",
        label: "View",
        labelAr: "عرض",
        isEnabled: false,
      },
      {
        id: "ingredient_2",
        value: "add",
        label: "Add",
        labelAr: "إضافة",
        isEnabled: false,
      },
      {
        id: "ingredient_3",
        value: "update",
        label: "Update",
        labelAr: "تحديث",
        isEnabled: false,
      },
      {
        id: "ingredient_4",
        value: "delete",
        label: "Delete",
        labelAr: "حذف",
        isEnabled: false,
      },
    ],
  },
  {
    id: 24,
    title: "Allergens",
    titleAr: "المواد المسببة للحساسية",
    permissions: [
      {
        id: "allergen_1",
        value: "view",
        label: "View",
        labelAr: "عرض",
        isEnabled: false,
      },
      {
        id: "allergen_2",
        value: "add",
        label: "Add",
        labelAr: "إضافة",
        isEnabled: false,
      },
      {
        id: "allergen_3",
        value: "update",
        label: "Update",
        labelAr: "تحديث",
        isEnabled: false,
      },
      {
        id: "allergen_4",
        value: "delete",
        label: "Delete",
        labelAr: "حذف",
        isEnabled: false,
      },
    ],
  },
  {
    id: 25,
    title: "Regions",
    titleAr: "المناطق",
    permissions: [
      {
        id: "region_1",
        value: "view",
        label: "View",
        labelAr: "منظر",
        isEnabled: false,
      },
      {
        id: "region_2",
        value: "add",
        label: "Add",
        labelAr: "إضافة",
        isEnabled: false,
      },
      {
        id: "region_3",
        value: "update",
        label: "Update",
        labelAr: "تحديث",
        isEnabled: false,
      },

      {
        id: "region_4",
        value: "delete",
        label: "Delete",
        labelAr: "حذف",
        isEnabled: false,
      },
    ],
  },
  {
    id: 26,
    title: "Cities",
    titleAr: "مدن",
    permissions: [
      {
        id: "city_1",
        value: "view",
        label: "View",
        labelAr: "منظر",
        isEnabled: false,
      },
      {
        id: "city_2",
        value: "add",
        label: "Add",
        labelAr: "إضافة",
        isEnabled: false,
      },
      {
        id: "city_3",
        value: "update",
        label: "Update",
        labelAr: "تحديث",
        isEnabled: false,
      },

      {
        id: "city_4",
        value: "delete",
        label: "Delete",
        labelAr: "حذف",
        isEnabled: false,
      },
    ],
  },
  {
    id: 27,
    title: "Rating & Feedback",
    titleAr: "التقييم وردود الفعل",
    permissions: [
      {
        id: "rating_1",
        value: "view",
        label: "View",
        labelAr: "منظر",
        isEnabled: false,
      },
      {
        id: "rating_2",
        value: "add",
        label: "Add",
        labelAr: "إضافة",
        isEnabled: false,
      },
      {
        id: "rating_3",
        value: "update",
        label: "Update",
        labelAr: "تحديث",
        isEnabled: false,
      },

      {
        id: "rating_4",
        value: "delete",
        label: "Delete",
        labelAr: "حذف",
        isEnabled: false,
      },
    ],
  },
  {
    id: 28,
    title: "POS(API Key)",
    titleAr: "نقاط البيع (مفتاح API)",
    permissions: [
      {
        id: "api_key_1",
        value: "view",
        label: "View",
        labelAr: "منظر",
        isEnabled: false,
      },
      {
        id: "api_key_3",
        value: "update",
        label: "Update",
        labelAr: "تحديث",
        isEnabled: false,
      },
    ],
  },
  {
    id: 29,
    title: "POS(Branch Sync)",
    titleAr: "نقاط البيع (مزامنة الفروع)",
    permissions: [
      {
        id: "branch_sync_1",
        value: "view",
        label: "View",
        labelAr: "منظر",
        isEnabled: false,
      },
      {
        id: "branch_sync_3",
        value: "update",
        label: "Update",
        labelAr: "تحديث",
        isEnabled: false,
      },
    ],
  },
  {
    id: 30,
    title: "POS(Menu Sync)",
    titleAr: "نقاط البيع (مزامنة القائمة)",
    permissions: [
      {
        id: "menu_sync_3",
        value: "update",
        label: "Update",
        labelAr: "تحديث",
        isEnabled: false,
      },
    ],
  },
  {
    id: 31,
    title: "Add Emails",
    titleAr: "إضافة رسائل البريد الإلكتروني",
    permissions: [
      {
        id: "add_emails_1",
        value: "view",
        label: "View",
        labelAr: "عرض",
        isEnabled: false,
      },
      {
        id: "add_emails_3",
        value: "update",
        label: "Update",
        labelAr: "تحديث",
        isEnabled: false,
      },
    ],
  },
  {
    id: 32,
    title: "App Settings",
    titleAr: "إعدادات التطبيق",
    permissions: [
      {
        id: "app_settings_1",
        value: "view",
        label: "View",
        labelAr: "عرض",
        isEnabled: false,
      },
      {
        id: "app_settings_3",
        value: "update",
        label: "Update",
        labelAr: "تحديث",
        isEnabled: false,
      },
    ],
  },
  {
    id: 33,
    title: "Terms And Condtions",
    titleAr: "الشروط والأحكام",
    permissions: [
      {
        id: "term_condition_1",
        value: "view",
        label: "View",
        labelAr: "عرض",
        isEnabled: false,
      },
      {
        id: "term_condition_3",
        value: "update",
        label: "Update",
        labelAr: "تحديث",
        isEnabled: false,
      },
    ],
  },
  {
    id: 34,
    title: "Privacy Policy",
    titleAr: "سياسة الخصوصية",
    permissions: [
      {
        id: "privacy_policy_1",
        value: "view",
        label: "View",
        labelAr: "عرض",
        isEnabled: false,
      },
      {
        id: "privacy_policy_3",
        value: "update",
        label: "Update",
        labelAr: "تحديث",
        isEnabled: false,
      },
    ],
  },
  {
    id: 35,
    title: "Vehicles",
    titleAr: "المركبات",
    permissions: [
      {
        id: "vehicle_1",
        value: "view",
        label: "View",
        labelAr: "عرض",
        isEnabled: false,
      },
      {
        id: "vehicle_2",
        value: "add",
        label: "Add",
        labelAr: "إضافة",
        isEnabled: false,
      },
      {
        id: "vehicle_3",
        value: "update",
        label: "Update",
        labelAr: "تحديث",
        isEnabled: false,
      },

      {
        id: "vehicle_4",
        value: "delete",
        label: "Delete",
        labelAr: "حذف",
        isEnabled: false,
      },
    ],
  },
  {
    id: 36,
    title: "User Activity",
    titleAr: "نشاط المستخدم",
    permissions: [
      {
        id: "user_activity_1",
        value: "view",
        label: "View",
        labelAr: "عرض",
        isEnabled: false,
      },
    ],
  },
  {
    id: 37,
    title: "Eidiyah",
    titleAr: "بطاقة هدية",
    permissions: [
      {
        id: "gift_card_1",
        value: "view",
        label: "View",
        labelAr: "عرض",
        isEnabled: false,
      },
      {
        id: "gift_card_2",
        value: "add",
        label: "Add",
        labelAr: "إضافة",
        isEnabled: false,
      },
      {
        id: "gift_card_3",
        value: "update",
        label: "Update",
        labelAr: "تحديث",
        isEnabled: false,
      },

      {
        id: "gift_card_4",
        value: "delete",
        label: "Delete",
        labelAr: "حذف",
        isEnabled: false,
      },
    ],
  },
  {
    id: 38,
    title: "Eidiyah Usage",
    titleAr: "استخدام بطاقة الهدايا",
    permissions: [
      {
        id: "gift_card_usage_1",
        value: "view",
        label: "View",
        labelAr: "عرض",
        isEnabled: false,
      },
    ],
  },
  {
    id: 39,
    title: "Eidiyah Deep Link",
    titleAr: "رابط العيدية العميق",
    permissions: [
      {
        id: "dynamic_link_1",
        value: "view",
        label: "View",
        labelAr: "عرض",
        isEnabled: false,
      },
      {
        id: "dynamic_link_2",
        value: "add",
        label: "Add",
        labelAr: "إضافة",
        isEnabled: false,
      },
    ],
  },
  {
    id: 40,
    title: "Eidiyah Settings",
    titleAr: "إعدادات العيدية",
    permissions: [
      {
        id: "gift_card_settings_1",
        value: "view",
        label: "View",
        labelAr: "عرض",
        isEnabled: false,
      },
      {
        id: "gift_card_settings_3",
        value: "update",
        label: "Update",
        labelAr: "تحديث",
        isEnabled: false,
      },
    ],
  },
]

export const notificationsStatus = {
  1: "Sent to branch",
  2: "Preparing the order",
  3: "Ready for collection",
  4: "Collected",
  5: "Cancelled",
  6: "Cancelled by Customer",
}

export const ticketListsStatus = {
  1: "Pending",
  2: "Open",
  3: "In progress",
  4: "Resolved",
  5: "Closed",
  6: "Rejected",
}

export const statusListStatus = {
  1: {
    get text() {
      return i18next.t("Sent To Branch")
    },
    color: "#4A90E2",
  }, // Blue
  2: {
    get text() {
      return i18next.t("Start Preparing")
    },
    color: "#F5A623",
  }, // Orange
  3: {
    get text() {
      return i18next.t("Prepared")
    },
    color: "#ef0774",
  }, // Pink
  4: {
    get text() {
      return i18next.t("Collected")
    },
    color: "#50E3C2",
  }, // Teal
  5: {
    get text() {
      return i18next.t("Cancelled")
    },
    color: "#FF4D4F",
  }, // Red
  6: {
    get text() {
      return i18next.t("Sent To Branch Failed")
    },
    color: "#FF4D4F",
  }, // Red
}

export const bookingStatus = {
  1: "Pending",
  2: "Open",
  3: "Confirmed",
  4: "Completed",
  5: "Cancelled",
  6: "Rejected",
}
export const orderStatus = {
  1: "Sent To Branch",
  2: "Start Preparing",
  3: "Prepared",
  4: "Collected",
  5: "Cancelled",
}

// (for payment-methods) reports
export const groupByForPaymentMethods = [
  {
    label: "None",
    value: "",
  },
  {
    label: "Branch",
    value: "branch",
  },
  {
    label: "Order Type",
    value: "orderType",
  },
  {
    label: "Date",
    value: "date",
  },
  {
    label: "Hour",
    value: "hour",
  },
  {
    label: "Month",
    value: "month",
  },
  {
    label: "Year",
    value: "year",
  },
  {
    label: "Quarter",
    value: "quarter",
  },
  {
    label: "Half",
    value: "half",
  },
  {
    label: "Day Of Month",
    value: "dayOfMonth",
  },
  {
    label: "Week",
    value: "week",
  },
  {
    label: "Day Of Year",
    value: "dayOfYear",
  },
  {
    label: "Day Of Week",
    value: "dayOfWeek",
  },
]

export const paymentMethodTypes = [
  // {
  //   label: "Cash On Delivery",
  //   value: "COD",
  // },
  {
    label: "Card",
    value: "CARD",
  },
  {
    label: "Apple Pay",
    value: "APPLE",
  },
  // {
  //   label: "Tap",
  //   value: "TAP",
  // },
  {
    label: "Al-Rajhi Bank",
    value: "ALRAJHI_BANK",
  },
  {
    label: "Namq Rewards",
    value: "HALF_MILLION_REWARDS",
  },
  // {
  //   label: "Checkout",
  //   value: "CHECKOUT",
  // },
  // {
  //   label: "Full Discount or Rewards",
  //   value: "FULL_DISCOUNT_OR_REWARDS",
  // },
  {
    label: "Full Discount",
    value: "FULL_DISCOUNT",
  },
  {
    label: "Partial Payment",
    value: "PARTIAL",
  },
]

export const apexBarChartOptions = {
  chart: {
    toolbar: {
      show: false,
    },
  },
  plotOptions: {
    bar: {
      horizontal: true,
    },
  },
  dataLabels: {
    enabled: true,
  },

  colors: ["#34c38f"],
  grid: {
    borderColor: "#f1f1f1",
  },
  xaxis: {},
}

export const groupByBusinessTaxReport = [
  {
    label: "Branch",
    value: "branch",
  },
  {
    label: "Order",
    value: "order",
  },
]

export const salesByForSales = [
  {
    label: "Branch",
    value: "branch",
    colName: "branchName",
    colNameAr: "branchNameAr",
  },
  {
    label: "Category",
    value: "category",
    colName: "categoryName",
    colNameAr: "categoryNameAr",
  },
  {
    label: "Item",
    value: "item",
    colName: "itemName",
    colNameAr: "itemNameAr",
  },
  {
    label: "Modifier",
    value: "modifier",
    colName: "modifierName",
    colNameAr: "modifierNameAr",
  },
  {
    label: "Order Type",
    value: "orderType",
    colName: "orderType",
    colNameAr: "orderType",
  },
  {
    label: "Customer",
    value: "customer",
    colName: "customerName",
    colNameAr: "customerName",
  },
  {
    label: "Coupon",
    value: "coupon",
    colName: "couponName",
    colNameAr: "couponNameAr",
  },
  {
    label: "Platform",
    value: "platform",
    colName: "platform",
    colNameAr: "platform",
  },
  {
    label: "Payment Method",
    value: "paymentMethod",
    colName: "",
    colNameAr: "",
  },
  {
    label: "Customer",
    value: "customer",
    colName: "paymentMethod",
    colNameAr: "paymentMethod",
  },
  {
    label: "Discount",
    value: "promotion",
    colName: "promotionName",
    colNameAr: "promotionName",
  },
  {
    label: "City",
    value: "city",
    colName: "cityName",
    colNameAr: "cityNameAr",
  },
  {
    label: "Region",
    value: "region",
    colName: "regionName",
    colNameAr: "regionNameAr",
  },
  {
    label: "Country",
    value: "country",
    colName: "countryName",
    colNameAr: "countryNameAr",
  },
]

export const groupByForSales = [
  {
    label: "None",
    value: "",
  },
  {
    label: "Branch",
    value: "branch",
  },
  {
    label: "Category",
    value: "category",
  },
  {
    label: "Item",
    value: "item",
  },
  {
    label: "Modifier",
    value: "modifier",
  },
  {
    label: "Order Type",
    value: "orderType",
  },
  {
    label: "Customer",
    value: "customer",
  },
  {
    label: "Coupon",
    value: "coupon",
  },
  {
    label: "Platform",
    value: "platform",
  },
  {
    label: "Payment Method",
    value: "paymentMethod",
  },
  {
    label: "Customer",
    value: "customer",
  },
  {
    label: "Discount",
    value: "promotion",
  },
  {
    label: "City",
    value: "city",
  },
  {
    label: "Region",
    value: "region",
  },
  {
    label: "Country",
    value: "country",
  },
  {
    label: "Date",
    value: "date",
  },
  {
    label: "Hour",
    value: "hour",
  },
  {
    label: "Month",
    value: "month",
  },
  {
    label: "Year",
    value: "year",
  },
  {
    label: "Quarter",
    value: "quarter",
  },
  {
    label: "Half",
    value: "half",
  },
  {
    label: "Day Of Month",
    value: "dayOfMonth",
  },
  {
    label: "Week",
    value: "week",
  },
  {
    label: "Day Of Year",
    value: "dayOfYear",
  },
  {
    label: "Day Of Week",
    value: "dayOfWeek",
  },
]

export const groupByForLoyaltyPoints = [
  {
    label: "Order",
    value: "order",
  },
  {
    label: "Customer",
    value: "customer",
  },
  {
    label: "Branch",
    value: "branch",
  },
  {
    label: "City",
    value: "city",
  },
  {
    label: "Region",
    value: "region",
  },
  {
    label: "Country",
    value: "country",
  },
]

export const branchSettingOptions = [
  { label: "Opening Hours", labelAr: "ساعات العمل", value: "openingHours" },
  { label: "City", labelAr: "مدينة", value: "cityId" },
  { label: "Users", labelAr: "المستخدمون", value: "users" },
  { label: "Discount", labelAr: "تخفيض", value: "discount" },
]

export const allOption = {
  get label() {
    return i18next.t("Select All")
  },
  value: "*",
}

export const disablePastDates = date => {
  const today = new Date()
  today.setHours(0, 0, 0, 0) // Reset time to midnight to compare only the date
  return date < today // Disable all dates before today
}

export const timesUTC = [
  "12 AM",
  "1 AM",
  "2 AM",
  "3 AM",
  "4 AM",
  "5 AM",
  "6 AM",
  "7 AM",
  "8 AM",
  "9 AM",
  "10 AM",
  "11 AM",
  "12 PM",
  "1 PM",
  "2 PM",
  "3 PM",
  "4 PM",
  "5 PM",
  "6 PM",
  "7 PM",
  "8 PM",
  "9 PM",
  "10 PM",
  "11 PM",
]

export const selectedTimes = [
  {
    dayOfWeek: "Sunday",
    openingTime: "00:00",
    closingTime: "23:59",
    closed: false,
  },
  {
    dayOfWeek: "Monday",
    openingTime: "00:00",
    closingTime: "23:59",
    closed: false,
  },
  {
    dayOfWeek: "Tuesday",
    openingTime: "00:00",
    closingTime: "23:59",
    closed: false,
  },
  {
    dayOfWeek: "Wednesday",
    openingTime: "00:00",
    closingTime: "23:59",
    closed: false,
  },
  {
    dayOfWeek: "Thursday",
    openingTime: "00:00",
    closingTime: "23:59",
    closed: false,
  },
  {
    dayOfWeek: "Friday",
    openingTime: "00:00",
    closingTime: "23:59",
    closed: false,
  },
  {
    dayOfWeek: "Saturday",
    openingTime: "00:00",
    closingTime: "23:59",
    closed: false,
  },
]

export const getPerPageOptions = totalCount => {
  if (totalCount <= 20) return [10]
  else if (totalCount <= 50) return [10, 20]
  else if (totalCount <= 100) return [10, 20, 50]
  return [10, 20, 50, 100]
}

export const editorModules = {
  toolbar: [
    [{ header: [1, 2, 3, 4, 5, 6, false] }], // Adds headings: h1, h2, h3, normal text
    ["bold", "italic", "underline"], // Formatting buttons
    [{ list: "ordered" }, { list: "bullet" }], // Lists
    ["link", "image"], // Add links and images
    [{ align: [] }], // Text alignment
    ["clean"], // Remove formatting button
  ],
}

export const editorFormats = [
  "header",
  "bold",
  "italic",
  "underline",
  "list",
  "bullet",
  "link",
  "image",
  "align",
]

export const todayDate = format(new Date(), "yyyy-MM-dd")

export const giftCardStatus = [
  {
    label: "Order",
    value: "order",
  },
]

export const giftCardTypes = {
  name: "type",
  type: "select",
  get options() {
    return [
      { label: i18next.t("All"), value: 0 },
      { label: i18next.t("Live"), value: 1 },
      { label: i18next.t("Upcoming"), value: 2 },
      { label: i18next.t("Expired"), value: 3 },
    ]
  },
  get placeholder() {
    return i18next.t("All")
  },
}
